import { render, staticRenderFns } from "./ChangeStatusDialog.vue?vue&type=template&id=45168870"
import script from "./ChangeStatusDialog.vue?vue&type=script&lang=js"
export * from "./ChangeStatusDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports